import { axios } from "../../lib/axios";

export const DeleteVideos = (payload: { ids: string[] }) => {
    return axios.delete(`/video/deleteMany/videos`, { data: payload })
        .then(response => response.data);
};
